export default __webpack_public_path__ + "static/media/4G_noAudio.3315c1ff.mp4";